import { BusinessRuleType, EntityDefinition } from '../types/entity-definition.interface';
import { Location } from '../types/location.interface';

export const locationDefinition: EntityDefinition<Location> = {
  entityType: 'Location',
  i18nBase: 'entities.location',
  list: {
    columns: [
      {
        field: 'name',
        headerKey: 'entities.location.fields.name',
        sortable: true,
        filterable: true,
        class: 'w-full min-w-[200px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
    ],
  },
  fields: [
    { field: 'name', labelKey: 'entities.location.fields.name', required: true, type: 'text', minLength: 3, maxLength: 50 },
    { field: 'assetId', labelKey: 'entities.location.fields.assetId', type: 'hidden', required: true },
  ],
  validationRules: [
    {
      type: BusinessRuleType.DELETE_VALIDATION,
      rule: (entity: Location) => !entity.isUsed,
      errorMessageKey: 'entities.location.messages.deleteError',
    },
    {
      type: BusinessRuleType.CREATE_VALIDATION,
      rule: (entity: Location, store) => {
        if (!store) return true;
        try {
          const locations = store.getData('Location')();
          return !(locations as Location[]).some(
            location => location.name.toLowerCase() === entity.name.toLowerCase() && location.assetId === entity.assetId,
          );
        } catch (error) {
          console.error('Error in CREATE_VALIDATION rule:', error);
          return true;
        }
      },
      errorMessageKey: 'entities.location.messages.duplicateError',
    },
    {
      type: BusinessRuleType.EDIT_VALIDATION,
      rule: (entity: Location, store) => {
        if (!store) return true;
        try {
          const locations = store.getData('Location')();
          return !(locations as Location[]).some(
            location =>
              location.name.toLowerCase() === entity.name.toLowerCase() &&
              location.assetId === entity.assetId &&
              location.id !== entity.id,
          );
        } catch (error) {
          console.error('Error in EDIT_VALIDATION rule:', error);
          return true;
        }
      },
      errorMessageKey: 'entities.location.messages.duplicateError',
    },
  ],
  actionButtons: {
    parent: {
      add: true,
      edit: true,
    },
  },
  formOptions: {
    showDeleteButton: true,
  },
  messages: {
    dialogTitles: {
      create: () => 'entities.location.messages.createTitle',
      edit: () => 'entities.location.messages.editTitleWithName',
      delete: () => 'common.confirmations.deleteTitleWithName',
    },
    buttons: {
      add: () => 'entities.location.messages.addButton',
      create: () => 'entities.location.messages.addButton',
      edit: () => 'entities.location.messages.editTitleWithName',
      delete: () => 'entities.location.messages.deleteTitle',
    },
    confirmDelete: () => 'entities.location.messages.deleteConfirm',
  },
  enableFiltering: true,
};
